<script lang="ts">
    import { onDestroy } from "svelte";
    import Router from "svelte-spa-router";
    import LoginPage from "./auth/LoginPage.svelte";
    import type { User } from "./auth/userStore";
    import { userStore } from "./auth/userStore";
    import ProjectEditor from "./pages/ProjectEditor.svelte";
    import ProjectPage from "./pages/ProjectPage.svelte";
    import ProjectSettings from "./pages/ProjectSettings.svelte";

    let user: User;
    const unsubscribeUser = userStore.subscribe((v) => {
        user = v;
    });
    onDestroy(unsubscribeUser);

    const routes = {
        "/": ProjectPage,
        "/project/:projectId": ProjectEditor,
        "/project/:projectId/settings": ProjectSettings,
    };
</script>

{#if user.loggedIn}
    <Router {routes} />
{:else}
    <LoginPage />
{/if}

<style type="text/scss">
    @import "./scss/global.scss";
</style>
